module.exports = __webpack_public_path__ + "static/media/light.269a2869.png";